import React, { useEffect, useState } from 'react'
import { IoClose } from 'react-icons/io5'
import { useNavigate, useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { GetProductByID, UpdateProduct } from '../API/ProductAPI'
import ProductInfo from '../ProductInfo/ProductInfo'
import AWS from 'aws-sdk';
import { GetPrice, UpdatePrice } from '../API/PriceAPI'

const S3_BUCKET = process.env.REACT_APP_IMAGE_S3_BUCKET;
const REGION = process.env.REACT_APP_REGION;
const APP_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const APP_SCRET_KEY = process.env.REACT_APP_SCRET_KEY;

AWS.config.update({
    accessKeyId: APP_ACCESS_KEY,
    secretAccessKey: APP_SCRET_KEY,
})

const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
})

const EditProduct = () => {
    const [formData, setFormData] = useState({
        name: ''
    })
    const [uploadFile, setUploadFile] = useState('');
    const [file, setFile] = useState('');
    const [objectKey, setObjectKey] = useState('')
    const [priceDetails, setPriceDetails] = useState([{
      select_currency: 'USD',
      price_data: '',
      isOpen: false,
      pricing_model: 'Standard pricing',
  }])

    const navigate = useNavigate()
    const location = useLocation()
    const ID = location.search.replace('?id:', '')

    const getProductData = async () => {
      const product = await GetProductByID(ID);
      setFormData(product);

      //Get image from AWS s3
      AWS.config.update({
        accessKeyId: APP_ACCESS_KEY,
        secretAccessKey: APP_SCRET_KEY,
        region: process.env.REACT_APP_REGION,
      });
  
      const s3 = new AWS.S3();
      const params = {
        Bucket: S3_BUCKET,
        Prefix: `${product.user_id}/${product.product_id}/`,
      };
  
      s3.listObjectsV2(params, (err, data) => {
        if (err) {
          toast.error(err, { autoClose: 5000 });
        } else {
          const urls = data.Contents.map((object) => {
            setObjectKey(object.Key)
            return `https://${S3_BUCKET}.s3.${AWS.config.region}.amazonaws.com/${object.Key}`;
          });
          urls[0] ? setFile(urls[0]) : setFile('')
        }
      });

      const price = await GetPrice()
      const data = price.filter((val) => val.product_id === ID)
      setPriceDetails(data)
    };

    const handleOnclickSave = async () => {
      const userID = localStorage.getItem("user")
      const postParams = {
        updateProduct_infoInput: {
          ...formData,
        },
      };

      const priceDataCheck = priceDetails.map((val) => val.price_data === '')

      if(priceDataCheck.includes(true) || formData.name === ''){
        toast.error("Please add valid product or price data", { autoClose: 5000 });
      } else {
        const result = await UpdateProduct(postParams);
        if (result !== null ) {
          //Upload image to AWS S3
          if(uploadFile){
            const s3 = new AWS.S3({
              accessKeyId: APP_ACCESS_KEY,
              secretAccessKey: APP_SCRET_KEY,
            });
            
            const paramsDelete = {
                Bucket: S3_BUCKET,
                Key: objectKey
            };
            
            s3.deleteObject(paramsDelete, (error, data) => {
              if (error) {
                toast.error(error, { autoClose: 5000 });
              }
            });

            const params = {
              ACL: 'public-read',
              Body: uploadFile,
              Bucket: S3_BUCKET,
              Key: `${userID}/${ID}/${uploadFile.name}`
            };

            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    console.log('Upload...', Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err) => {
                    if (err) toast.error(err.message, { autoClose: 5000 });
                })
          }

          //update price
          priceDetails.forEach(object => {
            delete object['isOpen'];
          });

          priceDetails.map(async (price) => {
              const postParams = {
                updatePrice_infoInput: {
                    ...price
                },
            };

            const result = await UpdatePrice(postParams)
              if (result) {
                navigate(`/product/${result.product_id}`)
              } else {
                  toast.error("Something went wrong", { autoClose: 5000 });
              }
          })
          toast.info("Product updated successfully", { autoClose: 5000 });
        } else {
          toast.error("Something went wrong", { autoClose: 5000 });
        }
      }
    };

    useEffect(() => {
      getProductData();
    }, []);

    return (
        <div>
            <div className="p-[20px] flex items-center justify-between border-b-[1px] border-[#ebeef1]">
                <div className="flex items-center">
                    <button onClick={() => navigate('/product')} className="border-r-[1px] border-gray-400 pr-[15px] mr-[15px]">
                        <IoClose className='text-gray-700 text-[18px]' />
                    </button>
                    <span className="text-sm font-medium text-[#414552]">Edit product</span>
                </div>
                <div className="flex gap-3 items-center">
                    <button onClick={handleOnclickSave} className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save product</button>
                </div>
            </div>
            <ProductInfo formData={formData} setFormData={setFormData} ID={ID} setUploadFile={setUploadFile} file={file} setFile={setFile} priceDetails={priceDetails} setPriceDetails={setPriceDetails} objectKey={objectKey}/>
        </div>
    )
}

export default EditProduct